import React from "react";

export const NameScreen = ({ value, error, onChange, onSubmit }) => (
  <div className="dedication name-screen" data-testid="name-screen">
    <div className="ded-scroll">
      <div className="ded-title">סוחר הים</div>
      <div className="ded-subtitle">ברוך הבא, סוחר!</div>
      <div className="ded-divider">· · ·</div>
      <div className="name-prompt-label">אנא הכנס את שמך:</div>
      <input
        className="name-input big"
        data-testid="player-name-input"
        type="text"
        maxLength={16}
        value={value}
        autoFocus
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") onSubmit();
        }}
        placeholder="השם שלך"
      />
      {error && (
        <div className="name-err" data-testid="player-name-error">
          נא להכניס שם כדי להמשיך
        </div>
      )}
      <button className="rbtn primary wide ded-btn" data-testid="player-name-submit" onClick={onSubmit}>
        ◄ המשך
      </button>
    </div>
    <div className="scanlines" />
  </div>
);
